import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extTime'
})
export class ExtTimePipe implements PipeTransform {

  transform(mins: number): string {
    let hours = Math.floor(mins/60);
    let minutes = mins % 60;

    let data = '';
    data += `${hours}:${minutes}`
    return data;
  }

}



// WEBPACK FOOTER //
// ./src/app/ext-time.pipe.ts